import { render, staticRenderFns } from "./RateDetailHandlingIndex.vue?vue&type=template&id=0f9a61ad&scoped=true&"
import script from "./RateDetailHandlingIndex.vue?vue&type=script&lang=js&"
export * from "./RateDetailHandlingIndex.vue?vue&type=script&lang=js&"
import style0 from "./RateDetailHandlingIndex.vue?vue&type=style&index=0&id=0f9a61ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a61ad",
  null
  
)

export default component.exports